// Environment configuration
export const config = {
  apiBaseUrl: `${import.meta.env.VITE_PROTOCOL}${import.meta.env.VITE_API_BASE_URL}`,
  // Apps SDK Builder is reached through the api gateway at `${apiBaseUrl}/apps-sdk`
  // (see appsSdkApi.ts) — no direct backend URL needed anymore.
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};